export function initKeyboardShortcuts() {
  const handleKeydown = (e) => {
    const isModifierPressed = e.ctrlKey || e.metaKey;

    // Menangkap Ctrl+K atau Cmd+K
    if (isModifierPressed && (e.key.toLowerCase() === 'k' || e.code === 'KeyK')) {
      e.preventDefault(); // Blokir fungsi default browser

      const searchInput = document.querySelector("form.ss-navbar-search .ss-navbar-search-input");
      if (searchInput) {
        setTimeout(() => {
          searchInput.focus();
        }, 10);
      }
    }
  };

  // Gunakan satu event listener di document
  document.addEventListener("keydown", handleKeydown);
}
